export const OPTHINES = {
  voteName: '2019poject/2019enthusiastic',
  themeColor: {
    activeBgColor: 'rgb(254, 126, 19)',
    inactiveBgColor: '#ffffff',
  },
  placeholder: '请输入姓名',
  tabs: [
    {
      tabName: '新闻资讯',
      tabPath: '/2019PAJS/RelativeNews',
    },
    {
      tabName: '投票通道',
      tabPath: '/2019PAJS/Activities',
    },
    {
      tabName: '明星打call',
      tabPath: '/2019PAJS/Video',
    },
    {
      tabName: '月度入围',
      tabPath: '/2019PAJS/List',
    },
  ],
  mustSearch: 'Button',
  buttonBg: 'rgb(37,155,16)',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
};
